import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactElement } from "react";
import { Tooltip } from "react-tooltip";
interface DropVoteProgressingProps {
  readonly current: number | null | undefined;
  readonly projected: number | null | undefined;
  readonly subtle?: boolean | undefined;
  readonly compact?: boolean | undefined;
}
export default function DropVoteProgressing(t0) {
  const $ = _c(22);
  const {
    current,
    projected,
    subtle: t1,
    compact: t2
  } = t0;
  const subtle = t1 === undefined ? false : t1;
  const compact = t2 === undefined ? false : t2;
  if (typeof current !== "number" || typeof projected !== "number") {
    return null;
  }
  const isProgressing = current !== projected;
  if (!isProgressing) {
    return null;
  }
  const isPositiveProgressing = current < projected;
  let color;
  let arrowColor;
  let wrapperClasses;
  let valueClasses;
  if (subtle) {
    color = isPositiveProgressing ? "tw-text-iron-400 tw-font-mono" : "tw-text-iron-600 tw-font-mono";
    arrowColor = "tw-text-iron-600";
    wrapperClasses = "tw-flex tw-items-center tw-gap-2";
    valueClasses = "tw-text-sm tw-font-bold tw-tracking-tight";
  } else {
    if (compact) {
      color = isPositiveProgressing ? "tw-text-emerald-400 tw-bg-emerald-500/10 tw-px-1.5 tw-py-0.5 tw-rounded-md tw-border tw-border-solid tw-border-emerald-500/15" : "tw-text-rose-400 tw-bg-rose-500/10 tw-px-1.5 tw-py-0.5 tw-rounded-md tw-border tw-border-solid tw-border-rose-500/15";
      arrowColor = "tw-text-iron-500";
      wrapperClasses = "tw-ml-0.5 tw-flex tw-items-center tw-gap-1.5";
      valueClasses = "tw-text-sm tw-font-bold tw-leading-5 tw-tabular-nums";
    } else {
      color = isPositiveProgressing ? "tw-text-emerald-500 tw-bg-emerald-500/10 tw-px-2 tw-py-0.5 tw-rounded tw-border tw-border-solid tw-border-emerald-500/20 tw-font-mono" : "tw-text-rose-500 tw-bg-rose-500/10 tw-px-2 tw-py-0.5 tw-rounded tw-border tw-border-solid tw-border-rose-500/20 tw-font-mono";
      arrowColor = "tw-text-iron-600";
      wrapperClasses = "tw-ml-0.5 tw-flex tw-items-center tw-gap-2";
      valueClasses = "tw-text-sm tw-font-bold tw-tracking-tight";
    }
  }
  const t3 = wrapperClasses;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      animationDuration: "2s"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const t5 = `drop-vote-progress-${current}-${projected}`;
  const t6 = `tw-flex-shrink-0 ${compact ? "tw-size-2" : "tw-size-2.5"} ${arrowColor}`;
  let t7;
  if ($[1] !== t6) {
    t7 = <FontAwesomeIcon icon={faArrowRight} className={t6} />;
    $[1] = t6;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const t8 = `${valueClasses} ${color}`;
  let t9;
  if ($[3] !== projected) {
    t9 = formatNumberWithCommas(projected);
    $[3] = projected;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  let t10;
  if ($[5] !== t8 || $[6] !== t9) {
    t10 = <span className={t8}>{t9}</span>;
    $[5] = t8;
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== t10 || $[9] !== t5 || $[10] !== t7 || $[11] !== wrapperClasses) {
    t11 = <span className={t3} style={t4} data-tooltip-id={t5}>{t7}{t10}</span>;
    $[8] = t10;
    $[9] = t5;
    $[10] = t7;
    $[11] = wrapperClasses;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = `drop-vote-progress-${current}-${projected}`;
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    };
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== projected) {
    t14 = formatNumberWithCommas(projected);
    $[14] = projected;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== t12 || $[17] !== t14) {
    t15 = <Tooltip id={t12} place="top" offset={8} opacity={1} style={t13}>Projected vote count at decision time:{" "}{t14}</Tooltip>;
    $[16] = t12;
    $[17] = t14;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== t11 || $[20] !== t15) {
    t16 = <>{t11}{t15}</>;
    $[19] = t11;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  return t16;
}